import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { InformationStatus } from '../model/InformationStatus';

@Injectable({
  providedIn: 'root'
})
export class InformationStatusService {
  private baseUrl = '/information-status/'

  constructor(private http: HttpClient) { }

  get(): Observable<InformationStatus[]> {
    return this.http.get<InformationStatus[]>(environment.API_URL + this.baseUrl);
  }

  post(statuses: InformationStatus[]): Observable<HttpResponse<Object>> {
    return this.http.post(environment.API_URL + this.baseUrl, statuses, { observe: 'response' });
  }
}
